import { ReceivingBankToDoController } from './receivingBankToDo.controller';
import template from './receivingBankToDo.html';

export const receivingBankToDoComponent = {
  name: 'createRequestReceivingBankToDo',
  restrict: 'E',
  template,
  controller: ReceivingBankToDoController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '=',
  },
};
